import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enUS from "~/locales/en-US/translation.json";
import esMX from "~/locales/es-MX/translation.json";

export const supportedLanguages = [
  { code: "en-US", name: "English", iso2: "EN" },
  { code: "es-MX", name: "Español", iso2: "ES" },
] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number]["code"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "en-US": { translation: enUS },
      "es-MX": { translation: esMX },
    },
    fallbackLng: "en-US",
    supportedLngs: ["en-US", "es-MX"],
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "secure-onboarding-language",
    },
    interpolation: {
      escapeValue: true, // Enable XSS protection
    },
  });

export default i18n;
